export default __webpack_public_path__ + "static/media/bg.eda5d119.png";